import React, { useState } from 'react'
import { Box, AppBar, Toolbar, Typography, List, ListItem, Button, useMediaQuery, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import LoginDialog from '../../Components/CustomizedModels/LoginModel';
import toast from 'react-hot-toast';
import ForgotPasswordModal from '../../Components/CustomizedModels/ForgotPassowrd';
import OtpLogin from '../../Components/CustomizedModels/OtpLogin';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/Icon2.png';

function HomePageNavBar() {
    const theme = useTheme();
    const navigate = useNavigate();
    const [openLogin, setOpenLogin] = useState(false);
    const [openForgotPassword, setOpenForgotPassword] = useState(false);
    const [openOtpLogin, setOpenOtpLogin] = useState(false);

    const handleForgotPasswordOpen = () => {
        setOpenForgotPassword(true);
        setOpenLogin(false);
    };

    const handleForgotPasswordClose = () => {
        setOpenForgotPassword(false);
    };

    const handleLoginOpen = () => {
        const userDetails = JSON.parse(localStorage.getItem('userDetails'));

        if (userDetails) {
            if (userDetails?.role === 'admin') {
                navigate('/admin/dashboard');
            }
            else if (userDetails?.role === 'super_admin') {
                navigate('/superAdmin/dashboard');
            }
            else if (userDetails?.role === 'stock_manager') {
                navigate('/storemanager/stockmanagement');
            }
            else if (userDetails?.role === 'production_manager') {
                navigate('/productionmanager/dashboard');
            }
            else {
                navigate('/');
            }
        } else {
            setOpenLogin(true);
        }
    };

    const handleLoginClose = () => {
        setOpenLogin(false);
    };

    const handleOtpLogin = () => {
        setOpenLogin(false);
        setOpenOtpLogin(true);
    };

    const handleOtpLoginClose = () => {
        setOpenOtpLogin(false);
    };

    const handleLoginSuccess = () => {
        toast.success('Logged in successfully');
        handleLoginClose();
        const userDetails = JSON.parse(localStorage.getItem('userDetails'));
        if (userDetails?.role === 'admin') {
            navigate('/admin/dashboard');
        }
        else if (userDetails?.role === 'super_admin') {
            navigate('/superAdmin/dashboard');
        }
        else if (userDetails?.role === 'stock_manager') {
            navigate('/storemanager/stockmanagement');
        }
        else if (userDetails?.role === 'production_manager') {
            navigate('/productionmanager/dashboard');
        }
        else {
            navigate('/');
        }
        window.location.reload();
    };

    const handleLoginError = (errorMessage) => {
        toast.error(errorMessage || 'Login failed');
        console.error('Login failed:', errorMessage);
    };

    return (
        <Box sx={{ width: '100%', zIndex: 1000 }}>
            <AppBar
                position="static"
                sx={{
                    backgroundColor: '#F6F8FF',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                    padding: { xs: '0 0.5rem', md: '0 1.5rem' },
                }}
            >
                <Toolbar
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: { xs: 0.5, md: 1 },
                        maxWidth: { md: '1200px' },
                        margin: '0 auto',
                        width: '100%',
                    }}
                >
                    <img
                        src={logo}
                        alt="Inventory ERP Logo"
                        style={{ height: '60px', objectFit: 'contain' }}
                    />                    <List sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        color: '#000',
                        gap: { xs: '5px', sm: '10px', md: '20px' },
                        flexWrap: 'nowrap',
                        overflowX: 'auto',
                        '&::-webkit-scrollbar': {
                            display: 'none'
                        },
                        msOverflowStyle: 'none',
                        scrollbarWidth: 'none',
                        padding: { xs: '0 5px', md: '0 10px' }
                    }}>
                        <ListItem
                            component={Link}
                            to="/"
                            sx={{
                                padding: { xs: '4px 8px', md: '8px 16px' },
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                color: '#6C87AE',
                                whiteSpace: 'nowrap',
                                textDecoration: 'none',
                                fontSize: { xs: '0.75rem', md: '1rem' },
                                '&:hover': {
                                    backgroundColor: 'rgba(24, 20, 243, 0.1)',
                                    borderRadius: '4px'
                                }
                            }}
                        >
                            Home
                        </ListItem>
                        <ListItem
                            component={Link}
                            to="/about/terms"
                            target='_blank'
                            rel="noopener noreferrer"
                            sx={{
                                padding: { xs: '4px 8px', md: '8px 16px' },
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                color: '#6C87AE',
                                whiteSpace: 'nowrap',
                                textDecoration: 'none',
                                fontSize: { xs: '0.75rem', md: '1rem' },
                                '&:hover': {
                                    backgroundColor: 'rgba(24, 20, 243, 0.1)',
                                    borderRadius: '4px'
                                }
                            }}
                        >
                            About
                        </ListItem>
                        <ListItem
                            component={Link}
                            to="/about/contact"
                            target='_blank'
                            rel="noopener noreferrer"
                            sx={{
                                padding: { xs: '4px 8px', md: '8px 16px' },
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                color: '#6C87AE',
                                whiteSpace: 'nowrap',
                                textDecoration: 'none',
                                fontSize: { xs: '0.75rem', md: '1rem' },
                                '&:hover': {
                                    backgroundColor: 'rgba(24, 20, 243, 0.1)',
                                    borderRadius: '4px'
                                }
                            }}
                        >
                            Contact
                        </ListItem>
                    </List>
                    <Box sx={{ display: { xs: 'none', sm: 'flex' } }}>
                        <Button onClick={handleLoginOpen}
                            variant="contained"
                            sx={{ background: 'linear-gradient(96.14deg, #3A8EF6 -10.84%, #6F3AFA 196.74%)', borderRadius: '15px' }}>
                            Login
                        </Button>
                    </Box>
                </Toolbar>
            </AppBar>
            <LoginDialog
                open={openLogin}
                onClose={handleLoginClose}
                onForgotPassword={handleForgotPasswordOpen}
                onOtpLogin={handleOtpLogin}
                onLoginSuccess={handleLoginSuccess}
                onLoginError={handleLoginError}
            />
            <ForgotPasswordModal open={openForgotPassword} onClose={handleForgotPasswordClose} />
            <OtpLogin open={openOtpLogin} onClose={handleOtpLoginClose} />
        </Box>
    )
}

export default HomePageNavBar
